var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.sassStyles.root},[_c('mq-layout',{attrs:{"mq":['xs', 'sm', 'md', 'lg']}},[_c('StepsCompact')],1),_c('mq-layout',{attrs:{"mq":"xl+"}},[_c('StepsWide')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }